var path = 'app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/artifactSettings.html';
var html = "<form name=\"form\" class=\"container-fluid form-horizontal\" ng-controller=\"cfServerGroupArtifactSettingsCtrl as artifactSettingsCtrl\" novalidate>\n  <div class=\"modal-body\">\n    <cf-server-group-artifact-settings-selector command=\"command\" application=\"application\"></cf-server-group-artifact-settings-selector>\n  </div>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/artifactSettings.html
// module id = 1650
// module chunks = 0